(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["entici-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-entici-size-guide-open]');
    if (openButton) {
      const fieldset = openButton.closest('.variant-option--size');
      const dialog = fieldset ? fieldset.querySelector('[data-entici-size-guide-dialog]') : null;
      if (dialog && !dialog.open) {
        dialog.showModal();
      }
      return;
    }

    const closeButton = event.target.closest('[data-entici-size-guide-close]');
    if (closeButton) {
      const dialog = closeButton.closest('dialog');
      if (dialog) {
        dialog.close();
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
